import { Modal as AntModal } from "antd";
import { Modal as MobileModal } from "antd-mobile";
import { useCurrentBreakpointName } from "react-socks";
import React from "reactn";

export const Modal = ({ visible, children, closable, loginClass }) => {
	const breakpoint = useCurrentBreakpointName();
	if (breakpoint === "mobile") {
		return (
			<MobileModal
				className={loginClass ? loginClass : ""}
				visible={visible}
				footer={[]}
				closable={!!closable}
				destroyOnClose
			>
				<div style={{ padding: "20px" }}>{children}</div>
			</MobileModal>
		);
	}

	return (
		<AntModal
			visible={visible}
			footer={null}
			closable={!!closable}
			destroyOnClose
		>
			{children}
		</AntModal>
	);
};
